export function formatEligibleVerifierData(userList) {
    return (userList || [])
        .filter(user =>
            user.user_type &&
            user.user_type.user_type_display_name === "ABS" &&
            user.user_archived !== true
        )
        .map(user => ({
            id: user._id,
            full_name: `${user.user_fname} ${user.user_lname}`
        }))
        .sort((first, second) => first.full_name.localeCompare(second.full_name));
}

export function getEligibleScheduleVerifierIds(scheduleVerifierList, verifierList) {
    return (scheduleVerifierList || [])
        .map(verifier => verifier._id)
        .filter(verifierId => (verifierList || []).some(verifier => verifier.id === verifierId));
}

export function requiresNonScheduleVerifierConfirmation(verifierId, scheduleVerifierList) {
    const scheduleVerifierIds = (scheduleVerifierList || []).map(verifier => verifier._id);
    return verifierId !== "" &&
        scheduleVerifierIds.length > 0 &&
        !scheduleVerifierIds.includes(verifierId);
}
